<template>
  <div class="container">
    <h4 class="index__login-title app-title with-bar">
      Como deseja continuar?
      <div class="line-big"></div>
    </h4>
    <router-link to="/home/employees" tag="a" class="path__block">
      Acessar como Colaborador
    </router-link>
    <router-link to="/home/visitors" tag="a" class="path__block">
      Acessar como Visitante
    </router-link>
  </div>
</template>

<script>
import Loading from "vue-loading-overlay";

export default {
  data() {
    return {
      isLoading: false,
      fullPage: true,
    };
  },
  components: {
    Loading,
  },
  methods: {
    handleVisitor() {
      console.log("Visitor");
      this.$router.push({ name: "visitors" });
    },
  },
};
</script>

<style scoped>
.container{
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-content: center;
  height: 100%;
  gap: 20px;
  width: 100%;
}
</style>
